export const CREATE_ARTICLE_MASTER_REQUEST = 'CREATE_ARTICLE_MASTER_REQUEST';
export const CREATE_ARTICLE_MASTER_SUCCESS = 'CREATE_ARTICLE_MASTER_SUCCESS';
export const CREATE_ARTICLE_MASTER_FAILURE = 'CREATE_ARTICLE_MASTER_FAILURE';

export const UPDATE_ARTICLE_MASTER_REQUEST = 'UPDATE_ARTICLE_MASTER_REQUEST';
export const UPDATE_ARTICLE_MASTER_SUCCESS = 'UPDATE_ARTICLE_MASTER_SUCCESS';
export const UPDATE_ARTICLE_MASTER_FAILURE = 'UPDATE_ARTICLE_MASTER_FAILURE';

export const DELETE_ARTICLE_MASTER_REQUEST = 'DELETE_ARTICLE_MASTER_REQUEST';
export const DELETE_ARTICLE_MASTER_SUCCESS = 'DELETE_ARTICLE_MASTER_SUCCESS';
export const DELETE_ARTICLE_MASTER_FAILURE = 'DELETE_ARTICLE_MASTER_FAILURE';

export const FETCH_SINGLE_ARTICLE_MASTER_REQUEST = 'FETCH_SINGLE_ARTICLE_MASTER_REQUEST';
export const FETCH_SINGLE_ARTICLE_MASTER_SUCCESS = 'FETCH_SINGLE_ARTICLE_MASTER_SUCCESS';
export const FETCH_SINGLE_ARTICLE_MASTER_FAILURE = 'FETCH_SINGLE_ARTICLE_MASTER_FAILURE';

export const FETCH_ARTICLE_MASTER_DATA_REQUEST = 'FETCH_ARTICLE_MASTER_DATA_REQUEST';
export const FETCH_ARTICLE_MASTER_DATA_SUCCESS = 'FETCH_ARTICLE_MASTER_DATA_SUCCESS';
export const FETCH_ARTICLE_MASTER_DATA_FAILURE = 'FETCH_ARTICLE_MASTER_DATA_FAILURE';

export const FETCH_ARTICLE_MASTER_BY_ARTICLE_NUMBER_DATA_REQUEST = 'FETCH_ARTICLE_MASTER_BY_ARTICLE_NUMBER_DATA_REQUEST';
export const FETCH_ARTICLE_MASTER_BY_ARTICLE_NUMBER_DATA_SUCCESS = 'FETCH_ARTICLE_MASTER_BY_ARTICLE_NUMBER_DATA_SUCCESS';
export const FETCH_ARTICLE_MASTER_BY_ARTICLE_NUMBER_DATA_FAILURE = 'FETCH_ARTICLE_MASTER_BY_ARTICLE_NUMBER_DATA_FAILURE';

export const CREATE_ARTICLE_MASTER_FORM = 'CREATE_ARTICLE_MASTER_FORM';

export const ARTICLE_MASTER_FORM_RESET = 'ARTICLE_MASTER_FORM_RESET';

export const SET_RATIO_NAME_ARTICLE_MASTER = 'SET_RATIO_NAME_ARTICLE_MASTER';

export const SET_NON_RATIO_SIZE_DATA = 'SET_NON_RATIO_SIZE_DATA';

